module.exports = __webpack_public_path__ + "media/assets/images/flags/im-52ec3975fc8b4535d48cbaf3cac2d532.svg";